import { useMemo, useState } from "react";

import { useCard } from "../../../../../../reactQuery/cards";
import { currentUserId, isAdmin } from "../../../../../../utils/constants";
import { useCustomSearchParams } from "../../../../../../hooks/useCustomSearchParams";
import { useResponsive } from "../../../../../../hooks/useResponsive";
import { useSidebarMutations } from "./useSidebarMutations";
import { getResponseData } from "../../../../../../reactQuery/response";

export function useDetailSidebarState({ cardId, boardPermission }) {
  const [addWorklog, setAddWorklog] = useState(false);
  const [milestone] = useCustomSearchParams("milestone");
  const isMobile = useResponsive("down", "md");
  const { card } = useCard(cardId);
  const data = useMemo(() => getResponseData(card, {}), [card]);

  const checkBoardOwnerOrAdmin = useMemo(
    () =>
      isAdmin() ||
      data?.board?.owner_user_id === currentUserId() ||
      boardPermission?.is_admin,
    [boardPermission?.is_admin, data?.board?.owner_user_id]
  );

  const conditionCheck = useMemo(
    () =>
      checkBoardOwnerOrAdmin ||
      data?.assigned_to_user_id === currentUserId() ||
      data?.reporter === currentUserId(),
    [checkBoardOwnerOrAdmin, data?.assigned_to_user_id, data?.reporter]
  );

  const sidebarMutations = useSidebarMutations(cardId, data?.board_id, milestone);

  return {
    addWorklog,
    conditionCheck,
    data,
    isMobile,
    setAddWorklog,
    sidebarMutations,
    checkBoardOwnerOrAdmin,
  };
}
